import React, { useContext, useEffect, useState } from "react";
import userDefaultImage from "../../images/default-profile.png";
import SelectPS from "./SelectPS";

import Swal from "sweetalert2";
import { AppContext } from "../../contexts/AppContext";
import { UrlContext } from "../../contexts/UrlContext";

export default function ProjectSupporter({ project }) {
  const { users, projects, setProjects } = useContext(AppContext);
  const [selectedProjectSupporter, setSelectedProjectSupporter] = useState("");
  const [selectedProjectSupporterImage, setSelectedProjectSupporterImage] =
    useState(userDefaultImage);
  const [returnSuccess, setReturnSuccess] = useState(false);
  const [returnError, setReturnError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [showAddPS, setShowAddPS] = useState(false);
  const { API_URL } = useContext(UrlContext);

  useEffect(() => {
    // Filter only active users
    const activeUsers = users.filter((user) => user.isActive === 'yes');

    let usermail = users.map((user) => user.email).join(", ");
    let usermailArr = usermail.split(", ");
    let usernames = users.map((user) => user.username).join(", ");
    let usernamesArr = usernames.split(", ");
    let isActiveArr = activeUsers.map((user) => user.isActive).join(", ").split(", ");
    let usersNewList = [];
    usernamesArr.forEach((username, i) => {
      usersNewList.push({ label: username, value: usermailArr[i], isActive: isActiveArr[i] });
    });

    setUsersList(usersNewList);
  }, [users]);

  useEffect(() => {
    if (project?.project_supporter) {
      const newProjectSuporterList = [];
      project.project_supporter.split(", ").map((item) => {
        usersList.map((x) => {
          if (x.label === item) {
            newProjectSuporterList.push(x.value);
          }
        });
      });

      setSelectedProjectSupporter(newProjectSuporterList.join(","));
      const selectedUser = users?.find(
        (user) => user.email === newProjectSuporterList.join(",")
      );
      if (selectedUser) {
        if (selectedUser.profilePicture) {
          setSelectedProjectSupporterImage(selectedUser.profilePicture);
        } else {
          setSelectedProjectSupporterImage(userDefaultImage);
        }
      }
    }
  }, [usersList]);

  const updateProjectSupporter = (values) => {
    setShowAddPS(false);
    setReturnError(false);
    setLoading(true);
    const selectedUsersName = values.map((user) => user.label);
    const selectedUsersNameStr = selectedUsersName.join(", ");
    const selectedUsers = values.map((user) => user.value);
    const selectedUsersValue = selectedUsers.join(", ");
    setSelectedProjectSupporter(selectedUsersValue);
    const selectedUser = users.find(
      (user) => user.username === selectedUsersValue
    );
    if (selectedUser) {
      if (selectedUser.profilePicture) {
        setSelectedProjectSupporterImage(selectedUser.profilePicture);
      } else {
        setSelectedProjectSupporterImage(userDefaultImage);
      }
    } else {
      setSelectedProjectSupporterImage(userDefaultImage);
    }
    const projectSupporter = selectedUsersNameStr;
    const projectID = project.id;
    const selectedProject = projects.filter((proj) => proj.id === projectID)[0];
    const modifiedProject = {
      ...selectedProject,
      project_supporter: projectSupporter,
    };
    const projectData = {
      projectSupporter,
      projectID,
    };
    const ephToken = localStorage.getItem("eph-token");
    const token = JSON.parse(ephToken).value;

    fetch(`${API_URL}update-project-supporter`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(projectData),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        if (data.status === "success") {
          setReturnSuccess(true);
          setProjects(
            projects.map((project) =>
              project.id === modifiedProject.id ? modifiedProject : project
            )
          );
          setTimeout(() => {
            setReturnSuccess(false);
          }, 1500);
        } else {
          setReturnError(true);
        }
      })
      .catch((err) => {
        setLoading(false);
        setReturnError(true);
        Swal.fire({
          icon: "error",
          title: "Database connection error!",
          text: "Please logout and try again.",
          confirmButtonText: "OK",
        });
        console.log(err);
      });
  };

  return (
    <>
      {/* <div className="project-supporter" title="Project Supporter">
        {selectedProjectSupporter === "" ||
        selectedProjectSupporter === "Select" ? (
          <div style={{ width: "24px" }}></div>
        ) : (
          <img
            src={selectedProjectSupporterImage}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = userDefaultImage;
            }}
            width={24}
            height={24}
            className="rounded-circle"
            alt=""
          />
        )}
      </div>
      <select
        id="pjSpporter"
        className="pjSpporter-select"
        title="Project Supporter"
        value={selectedProjectSupporter}
        onChange={(e) => {
          setReturnError(false);
          updateProjectSupporter(e.target.value);
        }}
      >
        <option value="">Select</option>
        {users?.map((user) => (
          <option key={user.username} value={user.username}>
            {user.username}
          </option>
        ))}
      </select> */}

      <div className="prjsupporter-main-div">
        <div className="wrap-project-spuporter">
          <SelectPS
            users={users}
            returnSuccess={returnSuccess}
            returnError={returnError}
            loading={loading}
            setShowAddPS={setShowAddPS}
            showAddPS={showAddPS}
            placeholder="Select . ."
            isMulti
            onChange={(values) => updateProjectSupporter(values)}
            options={usersList}
            value={usersList.filter((obj) =>
              selectedProjectSupporter?.includes(obj.value)
            )}
          />
        </div>
      </div>
    </>
  );
}
